// extracted by mini-css-extract-plugin
module.exports = {"link":"link___1qjDU","spaceCompact":"spaceCompact___3k_WT"};